import React, { Fragment, memo } from 'react';
import { useForm } from 'react-hook-form';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { orderCancelReasonApi } from '@app/store';
import { OrderCancelReasonDTO } from '@app/common';
import { Button, Form, Panel } from '@app/components';
import { OrderCancelReasonForm } from './OrderCancelReasonForm';
import { OrderCancelReasonFormValues } from './order-cancel-reason-form.helpers';
import { useToast, useTriptych } from '@app/hooks';
import { OrderCancelReasonCard } from './OrderCancelReasonCard';

export const OrderCancelReasonCreate = memo(() => {
  const toast = useToast();

  const triptych = useTriptych()

  const [create, { isLoading, error: apiErrors }] = orderCancelReasonApi.useCreateOneOrderCancelReasonsMutation();

  const formMethods = useForm<OrderCancelReasonFormValues>({
    resolver: classValidatorResolver(OrderCancelReasonDTO),
    defaultValues: {
      reason: ''
    },
  });

  const onCreate = async (formValues: OrderCancelReasonFormValues) => {
    try {
      const orderCancelReason = await create(formValues).unwrap();

      triptych.close({ mode: 'UPDATE', data: orderCancelReason });

      toast.success('Votre raison d\'annulation a bien été ajoutée.')
    } catch {
      toast.error('Une erreur est survenue lors de la création de votre raison d\'annulation.')
    }
  }

  return (
    <Fragment>
      <OrderCancelReasonCard
        formMethods={formMethods}
        toggle={() => triptych.toggle()} />

      <Panel.Content>

        <Form formMethods={formMethods} apiErrors={apiErrors}>

          <Panel.FormContainer>

            <OrderCancelReasonForm />

          </Panel.FormContainer>

          <Panel.Actions>
            <Button
              title="Retour"
              grow
              large
              bordered
              onPress={() => triptych.close()} />

            <Button
              loading={isLoading}
              title="Valider"
              onPress={formMethods.handleSubmit(onCreate)}
              grow
              large />
          </Panel.Actions>

        </Form>

      </Panel.Content>
    </Fragment>
  );
});
